import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared/shared.module';
import { CategoryComponent } from './category.component';


@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    CategoryComponent
  ]
})

export class InventoryCategoryModule { }


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/inventory/category/sys/inventory-category.module.ts